import React from "react";
import s from "./Card.module.scss";
import { Skeleton } from "antd";
import clsx from "clsx";
type PropType = {
  isLoading: boolean;
  title: string;
  value: number;
};
function Card({ isLoading, title, value }: PropType) {
  if (isLoading) {
    return (
      <div className={s.wrapper}>
        <Skeleton active title={false} paragraph={{ rows: 1, width: "100%" }} />
        <Skeleton active title={false} paragraph={{ rows: 1, width: "70%" }} />
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <h6 className={s.title}>{title}</h6>
      <p className={clsx(s.value, { [s.failed]: title.includes("fail") })}>
        {value.toLocaleString()}
      </p>
    </div>
  );
}

export default Card;
